import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  activityType: string;
};

export const ProductActivityTypeCell = ({ activityType }: Props) => <span className={desktopTruncateStyle}>{activityType}</span>;
